export const URL_CHECKOUT_TOKEN = "checkoutToken";
export const URL_MERCHANT = "merchantUrl";
export const URL_ORDER_ID = "orderId";
export const SUCCESS_URL = "merchantSuccessUrl";
export const FAILURE_URL = "merchantFailureUrl";
export const CANCEL_URL = "merchantCancelUrl";
export const URL_ORDER_TOKEN = "orderToken";
export const LANG = "lang";
